/** Metro excludes native AsyncStorage from app-web. Keep the same attempt
 * keys in browser storage; async methods turn denied storage access into
 * rejections handled by the attempt hooks, rather than render failures. */
const storage = {
  async getItem(key: string): Promise<string | null> {
    return localStorage.getItem(key);
  },
  async setItem(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value);
  },
  async removeItem(key: string): Promise<void> {
    localStorage.removeItem(key);
  },
};

export default storage;

export function clearStoredVendorAttempts(): void {
  for (let index = localStorage.length - 1; index >= 0; index--) {
    const key = localStorage.key(index);
    if (key?.startsWith("buy-on-behalf:")) localStorage.removeItem(key);
  }
}
